import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import type { ProjectCardWithInvoices } from "@msuite/utils/types";
import React from "react";
import { useProjectsFilterController } from "@/components/projects";
import { useMembers } from "@/hooks/use-members";
import { useProjects } from "@/hooks/use-projects";
import { useWorkspaces } from "@/hooks/use-workspaces";
import { ProjectsMenu } from "./projects-menu";
import { columns } from "./table-config";

export function Projects() {
	/** Query */
	const { projects, queryKey, isLoading, refetch } = useProjects();
	const { members } = useMembers({ capabilities: ["manage-project"] });
	const { workspaces } = useWorkspaces();
	const projectsFilter = useProjectsFilterController(projects, {
		users: members,
		workspaces,
	});

	/** Render */
	return (
		<React.Fragment>
			<ContentBox>
				<DataTable
					data={projectsFilter.filtered as Array<ProjectCardWithInvoices>}
					columns={columns}
					persistenceKey="projects-table"
					queryKey={queryKey}
					isLoading={isLoading}
					menu={
						<ProjectsMenu
							queryKey={queryKey}
							controller={projectsFilter}
						/>
					}
					refetch={refetch}
				/>
			</ContentBox>
		</React.Fragment>
	);
}
